export const UseCaseSelection = Object.freeze({
  ALL: 0, // 全て
  ORDER_SORT: 1, // オーダ仕分け
  NO_TASK_SORT: 2 // 方面別仕分け
})



// WEBPACK FOOTER //
// ./src/enums/use-case-selection.enums.js